/**
 * Two-step verification setup, required before anything else when the
 * district's policy requires it for this account (new or reset accounts, or
 * an administrator's request to re-enroll). The same steps are offered,
 * optionally, from User Preferences.
 */

import { useSession } from '@/lib/session'
import { Card } from '@/components/ui'
import { MfaSetup } from './MfaSetup'

export function MfaEnrollPage() {
  const { refresh } = useSession()
  return (
    <div className="boot">
      <Card title="Set up two-step verification">
        <MfaSetup
          intro={<p>Your account needs two-step verification before you continue. You will need an authenticator app (Microsoft Authenticator, Google Authenticator, 1Password or similar).</p>}
          doneLabel="Continue"
          onDone={() => void refresh()}
        />
      </Card>
    </div>
  )
}
